import { Selector } from '@ngxs/store';
import { ServerCommunicationState } from './server-communication.state';
import { RealTimeConnectionStatus } from './server-communication-status';
import { Sccs1ConnectionState } from './sccs1-connection/sccs1-connection.state';
import _ from 'lodash';

export class CommunicationFailureSelectors {
   @Selector([ServerCommunicationState.getRealtimeConnectionState, ServerCommunicationState.getIsRegistrationConfirmedAtServer])
   public static isRealTimeConnectionHealthy(realTimeConnectionStatus: RealTimeConnectionStatus, isRegistrationConfirmedAtServer: boolean): boolean {
      return realTimeConnectionStatus === RealTimeConnectionStatus.CONNECTED && isRegistrationConfirmedAtServer;
   }

   @Selector([Sccs1ConnectionState.getAvailableConnections])
   public static isSccs1ConnectionHealthy(availableConnections: string[]): boolean {
      return !_.isEmpty(availableConnections);
   }

   @Selector([CommunicationFailureSelectors.isRealTimeConnectionHealthy, CommunicationFailureSelectors.isSccs1ConnectionHealthy])
   public static isCommunicationHealthy(isRealTimeConnectionHealthy: boolean, isSccs1ConnectionHealthy: boolean) {
      return isRealTimeConnectionHealthy && isSccs1ConnectionHealthy;
   }
}
